var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class1"},[_vm._v(" Move the map around to place your marker where you want and click Next to place it. ")])}
var staticRenderFns = []

export { render, staticRenderFns }